import { makeStyles } from '@mui/styles';
import { caption, heading1Bold } from '../../../../shared/theme/text.styles';

export const useHighlightStyles = makeStyles((theme) => ({
  numbers: {
    WebkitTextStrokeColor: '#212121',
    WebkitTextStrokeWidth: '1px',
    WebkitTextFillColor: 'transparent',
    marginRight: '16px !important',
    cursor: 'ponter',
    textAlign: 'left',
    ...heading1Bold,

    '&:hover': {
      WebkitTextFillColor: theme.palette.text.main,
    },

    [theme.breakpoints.down('lg')]: {
      WebkitTextFillColor: theme.palette.text.main,
    },
  },

  text: {
    userSelect: 'none',
    color: '#BBBBBB',
    textAlign: 'left',
    ...caption,
  },
}));
